import { render, staticRenderFns } from "./sys_role.vue?vue&type=template&id=7e7b22d0&scoped=true"
import script from "./sys_role.vue?vue&type=script&lang=js"
export * from "./sys_role.vue?vue&type=script&lang=js"
import style0 from "./sys_role.vue?vue&type=style&index=0&id=7e7b22d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b22d0",
  null
  
)

export default component.exports